'use client';

import { useEffect, useState } from 'react';
import { useMenu } from '@/shared/providers/menu-provider';
import styles from './server-header.module.css';

export const HeaderMenuButton = () => {
  const { isOpen, isViewMenu, toggleMenu } = useMenu();
  const [isHydrated, setIsHydrated] = useState(false);
  const isMenuOpen = isHydrated && isOpen;

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return (
    <button
      className={`${styles.menuButton} ${
        isHydrated && !isViewMenu ? styles.menuButtonHidden : ''
      }`}
      type="button"
      aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
      aria-expanded={isMenuOpen}
      onClick={toggleMenu}
    >
      <img
        className={styles.menuIcon}
        src={
          isMenuOpen
            ? '/images/icons/minibanners_new/close-menu.png'
            : '/images/icons/minibanners_new/open-menu.png'
        }
        alt=""
        aria-hidden="true"
      />
    </button>
  );
};
